/**
 * Archived campaigns are hidden from navigation, so campaign filter dropdowns must hide them too.
 * The backend retains archived options with status so each consumer can choose its own behavior.
 */
import { CampaignStatuses } from 'src/store/constants';

export function excludeArchivedCampaignOptions<T extends { readonly id: string; readonly status?: string }> (
  options: readonly T[],
  keepIds?: readonly string[],
): T[] {
  return options.filter((option) => (
    option.status !== CampaignStatuses.ARCHIVED || keepIds?.includes(option.id) === true
  ));
}
